<template>
  <div class="validate-wrap" :class="{'extra-width': modalProps && modalProps.progress}">
    <questions v-if="modalProps" v-on='questionsEvents' v-bind='modalProps' :isLast='isLastPage'/>
  </div>
</template>

<script>
import api from "@/api";
import Questions from "@/components/auth/Validate";
export default {
  components: {
    questions: Questions
  },
  data() {
    return {
      currentPage: 0,
      questionList: [],
      componentResetKey: 0,
      questionsEvents: {
        next: this.handleNext,
        close: this.closePoll
      },
    };
  },
  computed: {
    progressBarData () {
      let data = {}
      data.currentIndex = this.currentPage;
      data.arr = this.questionList.map(page => {
        return page.title
      })
      return data
    },
    modalProps() {
      return {
        ...this.questionList[this.currentPage],
        progress: this.progressBarData
      };
    },
    isLastPage() {
      return this.currentPage === this.questionList.length - 1;
    },
  },
  mounted() {
    this.getQuestions();
    this.noScroll(true)
  },
  beforeDestroy() {
    this.noScroll(false)
  },
  methods: {
    noScroll (bool) {
      let body = document.getElementsByTagName('body')[0]
      if (bool)
        body.classList.add('no-scroll')
      else 
        body.classList.remove('no-scroll')
    },
    async getQuestions() {
      try {
        let active = await api.checkPolls();
        // selects smallest poll id from active polls
        active = active.data.active_poll.map((el) => el.activepolls).sort((a,b) => a-b)[0];
        let res = await api.getQuestions();
        if (res.data.data.length > 0) {
          let mapper = (el) => {
            // console.log(el);
            if (el.pls_id == active)
              return {
                pls_id: el.pls_id,
                title: el.title,
                questions: el.data,
                button: true,
                required: el.required,
              };
          };
          this.questionList = this.questionList.concat(
            // gets pages only from current poll and sorts pages acending on ppg_id
            res.data.data.map(mapper).filter((el) => el !== undefined).sort((a,b) => a.ppg_id - b.ppg_id)
          );
          this.componentResetKey++;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async handleNext(val) {
      val = Object.entries(val);
      let answers = [];
      for (const pair of val) {
        await this.checkForConditional(pair[1]);
        if (typeof pair[1] === "object") {
          if (pair[1].pqa_id) {
            // select
            answers.push({
              pqt_id: `${pair[0]}`,
              answer: [`${[pair[1].pqa_id]}`],
            });
          } else {
            // checkbox
            let selected = [];
            for (let checkbox of Object.keys(pair[1])) {
              if (pair[1][checkbox]) {
                selected.push(checkbox);
              }
            }
            if (selected.length > 0) {
              answers.push({
                pqt_id: pair[0],
                answer: selected,
              });
            }
          }
        } else {
          answers.push({
            pqt_id: pair[0],
            answer: pair[1],
          });
        }
      }
      // this.updateDynamicQuestions(val);
      this.postAnswers(answers);
      if (this.isLastPage) {
        this.closePoll();
        return;
      }
      this.currentPage++;
      this.componentResetKey++;
    },
    async checkForConditional(ans) {
      if (ans.conditional) {
        let res = await api.getConditional(ans);
        let newPage = {
          // title: 'Additional Questions',
          questions: [],
          button: true,
          required: true
        };
        for (const q of res.data.result) {
          newPage.questions.push(q);
        }
        this.questionList.splice(this.currentPage + 1, 0, newPage);
        this.questionList = [...this.questionList];
      }
    },
    // updateDynamicQuestions(answers) {
    //   const answerIds = [];
    //   for (const key in answers) {
    //     if (answers[key] == true) answerIds.push(Number(key));
    //   }

    //   const questions = this.questionList[1].questions;
    //   const newQuestions = [];
    //   for (let i = 0; i < questions.length; i++) {
    //     for (let j = 0; j < questions[i].pqa_ids.length; j++) {
    //       if (answerIds.includes(questions[i].pqa_ids[j])) {
    //         newQuestions.push(questions[i]);
    //       }
    //     }
    //   }
    //   this.questionList[1].questions = newQuestions;
    // },
    closePoll () {
      this.$emit('close', this.questionList[this.currentPage].pls_id);
    },
    async postAnswers(answers) {
      try {
        await api.postAnswers(answers, this.usr_id, this.token);
      } catch (error) {
        this.handleError(error);
        if (error?.response?.data?.message === "Poll already answered") {
          this.closePoll();
        }
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.validate-wrap {
  width: 75vw;
  max-width: 720px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: fixed;
  height: 70vh;
  overflow-y: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
</style>
